// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_UBd","cls2":"ReportList-cls2_K2a ReportList-cls1_UBd"};